import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">亚洲五码对照指南</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专业提供亚洲五码与欧码、美码、英码的换算对照服务，帮助消费者精准选码，避免退换货烦恼。
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">尺码分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/shoes" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">鞋子尺码对照</Link>
              <Link to="/category/clothing" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">服装尺码对照</Link>
              <Link to="/category/kids" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">童装尺码对照</Link>
            </div>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">热门文章</h4>
            <div className="flex flex-col gap-2">
              <Link to="/article/asian-five-code-guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">亚洲五码完全指南</Link>
              <Link to="/article/shoe-size-conversion-table" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">鞋码换算对照表</Link>
              <Link to="/article/online-shopping-size-tips" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">网购选码避坑指南</Link>
            </div>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">品牌介绍</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 亚洲五码对照指南. 保留所有权利.</p>
          <p className="text-xs text-foreground-500">专业尺码对照 · 精准选码不踩坑</p>
        </div>
      </div>
    </footer>
  );
}